
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/silicon-roundabout",
      function () {
        return require("private-next-pages/silicon-roundabout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/silicon-roundabout"])
      });
    }
  